import { __decorate, __metadata } from 'tslib';
import { Input, Component, NgModule } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { BrMaskerModule } from 'br-mask';
import { TooltipModule } from 'ng2-tooltip-directive';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { UiBsUtilModule } from '@wlp/ui-bs-util';
import { UiCInputModule } from '@wlp/ui-c-input';

let UiCRechargeComponent = class UiCRechargeComponent {
    constructor() { }
    ngOnInit() { }
};
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCRechargeComponent.prototype, "primaryMessage", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCRechargeComponent.prototype, "secondaryMessage", void 0);
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCRechargeComponent.prototype, "formValue", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCRechargeComponent.prototype, "tooltipMessage", void 0);
__decorate([
    Input(),
    __metadata("design:type", Object)
], UiCRechargeComponent.prototype, "errorMessages", void 0);
UiCRechargeComponent = __decorate([
    Component({
        selector: 'ui-c-recharge',
        template: "<div class=\"ui-c-recharge d-flex flex-column align-items-center justify-content-around\">\n  <div class=\"ion-text-center\" *ngIf=\"secondaryMessage !== null\">\n    {{ secondaryMessage }}\n  </div>\n  <div class=\"ion-text-start\">\n    {{ primaryMessage }}\n  </div>\n  <form class=\"d-flex flex-column justify-content-center align-items-center\" [formGroup]=\"formValue\">\n    <div class=\"details\">\n      <div class=\"detail-item\">\n\n        <ui-c-input [class]=\"'ion-input'\" [form]=\"formValue\" [errorMessages]=\"errorMessages\" [formName]=\"'valueField'\"\n          [isMoney]=\"true\" [placeholder]=\"'0,00'\" [maxlength]=\"'10'\" [type]=\"'tel'\">\n        </ui-c-input>\n\n      </div>\n    </div>\n  </form>\n</div>\n",
        styles: [""]
    }),
    __metadata("design:paramtypes", [])
], UiCRechargeComponent);

let UiCRechargeModule = class UiCRechargeModule {
};
UiCRechargeModule = __decorate([
    NgModule({
        declarations: [UiCRechargeComponent],
        imports: [
            CommonModule,
            IonicModule,
            ReactiveFormsModule,
            TooltipModule,
            BrMaskerModule,
            UiBsTranslateModule,
            UiBsUtilModule,
            UiCInputModule
        ],
        exports: [
            UiCRechargeComponent
        ]
    })
], UiCRechargeModule);

export { UiCRechargeComponent, UiCRechargeModule };
//# sourceMappingURL=wlp-ui-c-recharge.js.map
